import { of, Subject } from 'rxjs';
import { DemoAccountService } from './demo-account.service';

const createProspectDemoSubject = new Subject<any>();

const getMock: () => Partial<DemoAccountService> = () => ({
    create(prospectName: string, prospectData: any) {
        return of(null);
    },
    getProspectDemoAccounts() {
        return of([]);
    },
    getWorkshopAccounts() {
        return of([]);
    },
    createProspectDemo$: createProspectDemoSubject.asObservable()
});

export const demoAccountServiceMock = {
    getMock,
    provider: (Service: typeof DemoAccountService) => ({
        provide: Service,
        useValue: getMock()
    })
};
